import * as React from 'react';
import { Drawer, DrawerContent, DrawerItem } from '@progress/kendo-react-layout';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import AuthService from '../services/Auth.service.js';
import { useTranslation } from "react-i18next";

const CustomItem = (props) => {
    const { visible, ...others } = props;
    const arrowDir = props['data-expanded'] ? 'k-i-arrow-chevron-down' : 'k-i-arrow-chevron-right';
    return (
        <React.Fragment>
            {visible === false ? null :
                <DrawerItem {...others} >
                    <span className={'k-icon ' + props.icon} />
                    <p className={'k-item-text'}></p> {props.text}
                    {props['data-expanded'] !== undefined && <span className={"k-icon " + arrowDir} style={{ position: "absolute", right: 5 }} />}
                </DrawerItem>}
        </React.Fragment>
    );
};

function DrawerRouterContainer(props) {

    const { t } = useTranslation();

    const [items, setItems] = React.useState([]);

    React.useEffect(() => {

        var user = AuthService.getCurrentUser();
        var itemsMenu = [];

        if (user) {
            itemsMenu = [
                { text: t("Home_Title"), id: 0, icon: 'k-i-home', route: '/' },
                { separator: true },

                { text: t("Global_Label_Text_Farms"), id: 1, icon: 'k-i-style-builder', 'data-expanded': false },
                { text: t("Global_Label_Text_Farms"), id: 2, parentId: 1, route: '/Farms/' },
                { text: t("Global_Label_Text_Groups"), id: 3, parentId: 1, route: '/Groups/' },
                { text: t("Global_Label_Text_Animal_Movements"), id: 4, parentId: 1, route: '/AnimalMovements/' },
                { text: t("Global_Label_Text_Food_Receipts"), id: 5, parentId: 1, route: '/FoodReceipts/' },

                { text: t("Global_Label_Text_Orders"), id: 6, icon: 'k-i-shopping-cart', 'data-expanded': false },
                { text: t("Global_Label_Text_Information"), id: 7, parentId: 6, route: '/InformationOrderNavigations/' },
                { text: t("Global_Label_Text_Orders"), id: 8, parentId: 6, route: '/OrdersOrderNavigation/' },
                { text: t("Global_Label_Text_Order_Forecast"), id: 9, parentId: 6, route: '/OrderForecastOrderNavigation/' },

                { text: t("Global_Label_Text_Tasks"), id: 10, icon: 'k-i-clipboard-text', 'data-expanded': false },
                { text: t("Global_Label_Text_Tasks"), id: 11, parentId: 10, route: '//' },
                { text: t("Global_Label_Text_Calendar"), id: 12, parentId: 10, route: '//' },

                { text: t("Global_Label_Text_Informes"), id: 13, icon: 'k-i-track-changes', 'data-expanded': false },
                { text: t("Global_Label_Text_Informes"), id: 14, parentId: 13, route: '//' },



            ];

        }
        else {
            itemsMenu = [

            ];

        }

        setItems(itemsMenu);

    }, [localStorage.getItem("i18nextLng")]);

    const [state, setState] = React.useState({ drawerExpanded: window.innerWidth > 768, isSmallerScreen: window.innerWidth < 768 });

    const handleClick = () => {
        setState({ drawerExpanded: !state.drawerExpanded, isSmallerScreen: state.isSmallerScreen });
    };

    const onSelect = (ev) => {
        const currentItem = ev.itemTarget.props;
        const isParent = currentItem['data-expanded'] !== undefined;
        const nextExpanded = !currentItem['data-expanded'];

        const newData = items.map((item) => {
            const { selected, 'data-expanded': currentExpanded, id, ...others } = item;
            const isCurrentItem = currentItem.id === id;
            console.log(selected);
            return {
                selected: isCurrentItem,
                'data-expanded': isCurrentItem && isParent ? nextExpanded : currentExpanded,
                id,
                ...others
            };
        });

        if (!isParent && (window.innerWidth < 768))
            setState({ drawerExpanded: !state.drawerExpanded, isSmallerScreen: state.isSmallerScreen });

        setItems(newData);
        props.history.push(ev.itemTarget.props.route);
    }


    const data = items.map((item) => {
        const { parentId, ...others } = item;
        if (parentId !== undefined) {
            const parent = items.find(Parentitem => Parentitem.id === parentId)
            return {
                ...others,
                visible: parent['data-expanded']
            };
        }
        return item;
    });

    return (
        <div>
            <NavMenu onButtonClick={handleClick} />
            <Drawer
                expanded={state.drawerExpanded}
                mode={state.isSmallerScreen ? 'overlay' : 'push'}
                // mini={true}
                style={{ height: "100vh" }}
                items={data}
                position='start'
                item={CustomItem}
                onSelect={onSelect}
            >
                <DrawerContent>
                    <div>
                        <Container>
                            {props.children}
                        </Container>
                    </div>
                </DrawerContent>
            </Drawer>
        </div >
    );

}

export default withRouter(DrawerRouterContainer);